import React, { useEffect, useState } from "react";
import axios from "axios";
import { Cake, Gift, RefreshCw, Play, CheckCircle2, Clock } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL + "/api";

const fmtPhone = (p) => p || "—";
const fmtDays = (n) => {
  if (n === 0) return "сегодня";
  if (n === 1) return "завтра";
  if (n === -1) return "вчера";
  if (n < 0) return `${Math.abs(n)} дн. назад`;
  return `через ${n} дн.`;
};

export default function AdminBirthdays() {
  const [items, setItems] = useState([]);
  const [count, setCount] = useState(0);
  const [loading, setLoading] = useState(true);
  const [running, setRunning] = useState(false);
  const [lastRun, setLastRun] = useState(null);
  const [windowDays, setWindowDays] = useState(14);

  const load = async () => {
    setLoading(true);
    try {
      const r = await axios.get(`${API}/admin/bonuses/upcoming-birthdays?days=${windowDays}`,
                                { withCredentials: true });
      setItems(r.data.items || []);
      setCount(r.data.count || 0);
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => { load(); }, [windowDays]); // eslint-disable-line react-hooks/exhaustive-deps

  const runJob = async () => {
    setRunning(true);
    try {
      const r = await axios.post(`${API}/admin/bonuses/run-birthday-job`, {},
                                  { withCredentials: true });
      setLastRun(r.data);
      await load();
    } catch (e) {
      console.error(e);
      setLastRun({ error: e.response?.data?.detail || "Ошибка" });
    } finally {
      setRunning(false);
    }
  };

  const creditedNow = items.filter(i => i.bonus_already_credited).length;
  const pendingNow = items.length - creditedNow;

  return (
    <div data-testid="admin-birthdays" style={{ paddingBottom: "32px" }}>
      {/* Hero / explainer */}
      <div style={{ background: "linear-gradient(135deg,#1A1408 0%,#2E2010 100%)", color: "#fff",
        borderRadius: "10px", padding: "22px 24px", marginBottom: "22px",
        border: "1px solid rgba(197,160,89,0.3)" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "8px" }}>
          <Cake size={20} style={{ color: "#C5A059" }} />
          <div style={{ fontFamily: "Cormorant Garamond", fontSize: "22px", color: "#C5A059", fontWeight: 400 }}>
            Бонусы ко Дню рождения
          </div>
        </div>
        <div style={{ fontFamily: "Manrope", fontSize: "13px", color: "rgba(255,255,255,0.7)", lineHeight: 1.6 }}>
          Каждому клиенту с указанной датой рождения автоматически начисляется <strong style={{ color: "#fff" }}>50 000 ₸</strong> бонусов
          за 7 дней до Дня рождения. Бонусы действуют 14 дней (до +7 дней после ДР).
          Cron-задача выполняется ежедневно в 09:00 по Алматы.
        </div>
      </div>

      {/* Controls */}
      <div style={{ display: "flex", gap: "10px", alignItems: "center", flexWrap: "wrap", marginBottom: "18px" }}>
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <label style={{ fontFamily: "Manrope", fontSize: "12px", color: "#666" }}>Окно:</label>
          <select data-testid="window-days-select" value={windowDays}
                  onChange={(e) => setWindowDays(parseInt(e.target.value))}
                  style={{ padding: "6px 10px", borderRadius: "6px", border: "1px solid #e5e7eb",
                           fontFamily: "Manrope", fontSize: "13px", background: "white" }}>
            <option value={7}>7 дней</option>
            <option value={14}>14 дней</option>
            <option value={30}>30 дней</option>
            <option value={60}>60 дней</option>
          </select>
        </div>
        <button data-testid="refresh-birthdays-btn" onClick={load} disabled={loading}
                style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 14px",
                  borderRadius: "6px", border: "1px solid #d1d5db", background: "white",
                  cursor: loading ? "wait" : "pointer", fontFamily: "Manrope", fontSize: "13px" }}>
          <RefreshCw size={14} className={loading ? "animate-spin" : ""} /> Обновить
        </button>
        <button data-testid="run-birthday-job-btn" onClick={runJob} disabled={running}
                style={{ display: "flex", alignItems: "center", gap: "6px", padding: "7px 16px",
                  borderRadius: "6px", border: "none",
                  background: running ? "#999" : "linear-gradient(135deg,#C5A059,#D4B878)",
                  color: running ? "white" : "#0A0A0A",
                  cursor: running ? "wait" : "pointer", fontFamily: "Manrope", fontSize: "13px",
                  fontWeight: 700, letterSpacing: "0.05em" }}>
          <Play size={14} /> {running ? "Выполняется..." : "Запустить начисления"}
        </button>
      </div>

      {/* Stats */}
      <div style={{ display: "grid", gridTemplateColumns: "repeat(auto-fit,minmax(180px,1fr))", gap: "12px", marginBottom: "20px" }}>
        <StatCard label="Всего в окне" value={count} icon={<Cake size={16} />} />
        <StatCard label="Уже начислено" value={creditedNow} icon={<CheckCircle2 size={16} />} color="#10b981" />
        <StatCard label="Ожидают начисления" value={pendingNow} icon={<Clock size={16} />} color="#f59e0b" />
      </div>

      {/* Last-run summary */}
      {lastRun && (
        <div data-testid="last-run-result"
             style={{ background: lastRun.error ? "#fef2f2" : "#f0fdf4",
                      border: `1px solid ${lastRun.error ? "#fecaca" : "#bbf7d0"}`,
                      borderRadius: "8px", padding: "12px 16px", marginBottom: "18px",
                      fontFamily: "Manrope", fontSize: "13px" }}>
          {lastRun.error ? (
            <span style={{ color: "#dc2626" }}>Ошибка: {lastRun.error}</span>
          ) : (
            <span style={{ color: "#15803d" }}>
              ✓ Выполнено: <strong>{lastRun.granted_count}</strong> начислено,{" "}
              <strong>{lastRun.skipped_count}</strong> пропущено,{" "}
              <strong>{lastRun.errors}</strong> ошибок
            </span>
          )}
        </div>
      )}

      {/* Table */}
      {loading ? (
        <div style={{ textAlign: "center", padding: "60px 0", color: "#666", fontFamily: "Manrope" }}>Загрузка...</div>
      ) : items.length === 0 ? (
        <div data-testid="empty-state" style={{ textAlign: "center", padding: "60px 0",
                color: "#666", fontFamily: "Manrope", fontSize: "14px" }}>
          В выбранном окне нет клиентов с приближающимся Днём рождения.
        </div>
      ) : (
        <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: "10px", overflow: "hidden" }}>
          <table style={{ width: "100%", borderCollapse: "collapse" }}>
            <thead>
              <tr style={{ background: "#fafafa", borderBottom: "1px solid #e5e7eb" }}>
                <Th>Клиент</Th>
                <Th>Телефон</Th>
                <Th>Дата рождения</Th>
                <Th>До ДР</Th>
                <Th align="right">Статус</Th>
              </tr>
            </thead>
            <tbody>
              {items.map((i) => (
                <tr key={i.user_id} data-testid={`birthday-row-${i.user_id}`}
                    style={{ borderBottom: "1px solid #f1f5f9" }}>
                  <Td><strong>{i.name || "—"}</strong></Td>
                  <Td style={{ color: "#666" }}>{fmtPhone(i.phone)}</Td>
                  <Td>{i.birth_date}</Td>
                  <Td style={{ color: i.days_to_birthday <= 0 ? "#C5A059" : "#374151", fontWeight: 600 }}>
                    {fmtDays(i.days_to_birthday)}
                  </Td>
                  <Td align="right">
                    {i.bonus_already_credited ? (
                      <span style={{ display: "inline-flex", alignItems: "center", gap: "4px",
                              color: "#10b981", fontWeight: 600, fontSize: "12px" }}>
                        <Gift size={13} /> Начислено
                      </span>
                    ) : (
                      <span style={{ color: "#f59e0b", fontWeight: 600, fontSize: "12px" }}>
                        Ожидает
                      </span>
                    )}
                  </Td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
}

function StatCard({ label, value, icon, color = "#0A0A0A" }) {
  return (
    <div style={{ background: "white", border: "1px solid #e5e7eb", borderRadius: "10px", padding: "16px 18px" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "6px", color, marginBottom: "6px" }}>
        {icon}
        <div style={{ fontFamily: "Manrope", fontSize: "10px", letterSpacing: "0.12em", textTransform: "uppercase", color: "#888" }}>{label}</div>
      </div>
      <div style={{ fontFamily: "Cormorant Garamond", fontSize: "30px", fontWeight: 500, color }}>{value}</div>
    </div>
  );
}

const cellStyle = { fontFamily: "Manrope", fontSize: "13px", padding: "12px 16px", textAlign: "left" };
const Th = ({ children, align = "left" }) => (
  <th style={{ ...cellStyle, fontSize: "10px", color: "#888", letterSpacing: "0.12em",
               textTransform: "uppercase", fontWeight: 700, textAlign: align }}>{children}</th>
);
const Td = ({ children, style = {}, align = "left" }) => (
  <td style={{ ...cellStyle, color: "#0A0A0A", textAlign: align, ...style }}>{children}</td>
);
